// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0bf993f3","206":"b963afb4","430":"b256afc2","453":"d9e556fe","502":"f2ee0b3a","518":"b518043c","606":"749955ba","721":"2e82308b","858":"7769b2c8","908":"8db8a29d"}[chunkId] + ".chunk.js";
};